<template>
  <div>
    <div>
      <v-container>
        <notify-menu></notify-menu>
        <v-layout>
          <v-flex>
            <div>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">Start date</div>
                        <DatePickerWithoutButton
                          v-model="selectedDate.start"
                          @change="onChangeDate"
                        >
                          <input readonly :value="DateFormat(selectedDate.start)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">End date</div>
                        <DatePickerWithoutButton v-model="selectedDate.end" @change="onChangeDate">
                          <input readonly :value="DateFormat(selectedDate.end)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="text-xs-right">
                        <!-- <exportxlsx></exportxlsx> -->
                        <ExportGroup
                          v-model="showExportGroup"
                          :total="pagetotal"
                          filename="ticket-lists"
                          @onExport="onExportTicket"
                        >
                        </ExportGroup>
                        <v-btn
                          :loading="exportloading"
                          outline
                          color="grey"
                          class="ma-0 mb-0"
                          @click="handleExportTicket"
                        >
                          <em class="fas fa-file-export mr-1" /> {{ $t('export') }}
                        </v-btn>
                        <TicketEdit
                          :type="'add'"
                          :loading="loading"
                          @addTicket="onAddTicket"
                        ></TicketEdit>
                        <v-btn ripple color="primary" outline @click="handleGetAllData">
                          <em class="fa fa-refresh" />
                          <span class="pl-2">Refresh</span>
                        </v-btn>
                        <v-btn depressed color="primary" @click="showAdvancedSearch = true">
                          <v-icon>search</v-icon>
                          <span class="pl-2">{{ $t('Advanced search') }}</span>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div class="mb-3">
              <template v-if="countTicketLoading">
                <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
              </template>
              <template v-else>
                <SummaryTicket v-if="countTicketData" v-model="countTicketData"></SummaryTicket>.
              </template>
            </div>
            <div>
              <v-layout row wrap class="mb-0 pl-2">
                <v-flex xs12 class="pt-0">
                  <div class="text-xs-right">
                    <v-pagination
                      v-model="page"
                      :length="pagelength"
                      :total-visible="7"
                      @input="changepage"
                    ></v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-layout row wrap class="mb-0">
              <v-flex xs3 class="pa-2 mt-0">
                <div class="pa-2" style="background-color: #eee; border-radius: 8px">
                  <div>
                    <div>
                      Sort by
                      <DropdownMenu
                        v-model="filter.sortBy"
                        :outtericon="true"
                        :options="optionsSort"
                        :text-value="'value'"
                        :text-label="'label'"
                        @change="onSearch"
                      >
                        <span style="font-weight: bold">{{ sortByLabel }}</span>
                      </DropdownMenu>
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <template v-if="!['103235014977289'].includes(selectedBot.pageid)">
                    <div>Page</div>
                    <div>
                      <v-radio-group v-model="filter.pageid" class="mt-0" row @change="onSearch">
                        <v-radio label="All" value="" color="primary"></v-radio>
                        <v-radio
                          v-for="page in $store.state.com7pages"
                          :key="page.pageid"
                          :label="page.name"
                          :value="page.pageid"
                          color="primary"
                        ></v-radio>
                      </v-radio-group>
                    </div>
                  </template>
                  <div>Channel</div>
                  <div>
                    <v-radio-group v-model="filter.channel" class="mt-0" row @change="onSearch">
                      <v-radio label="All" value="all" color="primary"></v-radio>
                      <v-radio label="Facebook" value="facebook" color="primary"></v-radio>
                      <v-radio label="Line" value="line" color="primary"></v-radio>
                    </v-radio-group>
                  </div>
                  <div>Priority</div>
                  <div>
                    <multiselect
                      v-model="filter.priority"
                      tag-placeholder="Add this as new tag"
                      placeholder="Priority"
                      :searchable="false"
                      :options="optionsPriority"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                    ></multiselect>
                  </div>

                  <div class="mt-3">Status</div>
                  <div>
                    <multiselect
                      v-model="filter.status"
                      tag-placeholder="Add this as new tag"
                      placeholder="Status"
                      :searchable="false"
                      :options="optionsStatus"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                    ></multiselect>
                  </div>
                  <div class="mt-3">Tags</div>
                  <div>
                    <multiselect
                      v-model="filter.tags"
                      tag-placeholder="Add this as new tag"
                      placeholder="Tags"
                      :options="[]"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @input="onSearch"
                      @tag="addTag"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs9 class="mt-2">
                <div>
                  <div
                    class="my-0 pa-3"
                    style="background-color: #eee; border-radius: 10px; min-height: 400px"
                  >
                    <div v-if="loading">
                      <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                    </div>
                    <div v-else-if="!tickets.length">
                      <div class="text-xs-center pt-5" style="font-size: 25px">
                        <em style="font-size: 50px" class="far fa-folder-open" />
                        <br />
                        ไม่พบข้อมูล
                      </div>
                    </div>
                    <div v-else-if="!$store.state.loadingAgentGroups">
                      <div v-for="(item, k) in tickets" :key="item.id" class="mb-2">
                        <TicketItem :ticket.sync="tickets[k]" @ontransfer="onSearch"></TicketItem>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-dialog v-model="showAdvancedSearch" persistent width="600px">
          <AdvancedSearch @close="handleCloseSearch" @onSearch="onSearch"></AdvancedSearch>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import TicketItem from './TicketItem.vue'
import notifyMenu from './notifyMenu.vue'
import TicketEdit from './TicketEdit.vue'
import Multiselect from 'vue-multiselect'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import AdvancedSearch from './AdvancedSearch.vue'
import SummaryTicket from './Summary.vue'
import ExportGroup from '@/components/elements/ExportGroup.vue'

import { mapGetters } from 'vuex'
export default {
  components: {
    DatePickerWithoutButton,
    DropdownMenu,
    TicketItem,
    notifyMenu,
    Multiselect,
    TicketEdit,
    ScaleLoader,
    AdvancedSearch,
    SummaryTicket,
    ExportGroup
  },
  data() {
    return {
      exportloading: false,
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      loading: false,
      showAdd: false,
      optionsPriority: ['Low', 'Medium', 'High'],
      optionsTags: [],
      optionsStatus: ['Pending', 'Answered', 'Cancel', 'Closed'],
      optionsSort: [
        { label: 'Due by time', value: 'duedate' },
        { label: 'Created date', value: 'starttime' },
        { label: 'Priority', value: 'priority' },
        { label: 'Status', value: 'status' }
      ],
      input: {
        search: ''
      },
      filter: {
        search: '',
        sortBy: 'duedate',
        channel: 'all',
        priority: '',
        status: ['Pending', 'Answered'],
        pageid: '',
        tags: [],
        id: '',
        subject: '',
        assignGroupId: '',
        assignSubGroupId: '',
        assignAdminId: '',
        contact_phone: '',
        contact_email: ''
      },
      tickets: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      showAdvancedSearch: false,
      countTicketData: null,
      countTicketLoading: false,
      showExportGroup: false
    }
  },
  computed: {
    sortByLabel() {
      return this.optionsSort.find((el) => el.value == this.filter.sortBy).label
    },
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    // this.ticket2getticket(this.limit, this.offset)
    this.handleGetAllData()
  },
  methods: {
    handleExportTicket() {
      this.showExportGroup = true
    },
    formatFilter() {
      var data = {}

      if (this.filter.status) {
        data.status = this.filter.status.join(',').toLowerCase()
      }
      if (this.filter.priority) {
        data.priority = this.filter.priority
      }
      if (this.filter.search) {
        data.search = this.filter.search
      }
      if (this.filter.sortBy) {
        data.sortBy = this.filter.sortBy
      }
      if (this.filter.tags) {
        data.tags = this.filter.tags.join(',').toLowerCase()
      }
      if (this.selectedDate.start) {
        data.startTime = this.selectedDate.start
      }
      if (this.selectedDate.end) {
        data.endTime = this.selectedDate.end
      }

      if (this.filter.assignAdminId) {
        data.assignAdminId = this.filter.assignAdminId
      }
      if (this.filter.assignGroupId) {
        data.assignGroupId = this.filter.assignGroupId
      }
      if (this.filter.assignSubGroupId) {
        data.assignSubGroupId = this.filter.assignSubGroupId
      }
      if (this.filter.channel) {
        data.channel = this.filter.channel
      }
      if (this.filter.contact_email) {
        data.contact_email = this.filter.contact_email
      }
      if (this.filter.contact_phone) {
        data.contact_phone = this.filter.contact_phone
      }
      if (this.filter.id) {
        data.id = this.filter.id
      }
      if (this.filter.pageid) {
        data.pageid = this.filter.pageid
      }
      if (this.filter.subject) {
        data.subject = this.filter.subject
      }

      return data
    },
    handleTicket2getticket(data) {
      return new Promise((resolve, reject) => {
        api.ticket2getticket(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve(response)
          } else {
            reject()
          }
        })
      })
    },
    durationTime(start, end) {
      var startTime = start
      var endTime = end
      var minutes = moment
        .duration(moment(endTime, 'YYYY/MM/DD HH:mm').diff(moment(startTime, 'YYYY/MM/DD HH:mm')))
        .asMinutes()
        .toFixed(2)
      return minutes
    },
    onChangeDate() {
      this.handleGetAllData()
    },
    changepage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.handleGetAllData()
      }
    },
    onAddTicket() {
      this.onSearch()
    },
    showAddDialog() {
      this.showAdd = true
    },
    addTag(newTag) {
      this.optionsTags.push(newTag)
      this.filter.tags.push(newTag)
    },
    onSearch(payload) {
      this.filter.id = payload.ticket_id
      this.filter.subject = payload.ticket_name
      this.filter.assignGroupId = payload.group ? payload.group.id : ''
      this.filter.assignSubGroupId = payload.subgroup ? payload.subgroup.id : ''
      this.filter.assignAdminId = payload.agent_name ? payload.agent_name.adminid : ''
      this.filter.contact_phone = payload.phone_number
      this.filter.contact_email = payload.email
      this.filter.tags = payload.tags
      this.handleGetAllData()
      this.handleCloseSearch()
    },
    handleFormatDataBeforeGetTicket(data) {
      const tmpData = { ...data }
      Object.entries(this.filter).forEach(([key, value]) => {
        if (value && value.length) {
          if (Array.isArray(value)) {
            Object.assign(tmpData, { [key]: value.join(',').toLowerCase() })

            if (key == 'pageid' && value == '') {
              Object.assign(tmpData, { ['pageSelect']: 'all' })
            }
          } else {
            if (key == 'channel' && value == 'all') {
              //
            } else {
              Object.assign(tmpData, { [key]: value.toLowerCase() })
            }
          }
        }
      })

      if (['studio7'].includes(this.selectedBot.theme)) {
        const tempSelectPage = this.$store.state.com7pages.find((el) => {
          return el.pageid == this.filter.pageid
        })

        if (tempSelectPage) {
          // Object.assign(data, { pageSelect: tempSelectPage.name })
        } else {
          Object.assign(data, { pageSelect: 'All' })
        }
      }

      return tmpData
    },
    async handleGetAllData() {
      const vm = this

      let data = {
        pageid: vm.selectedBot.pageid,
        startTime: vm.selectedDate.start,
        endTime: vm.selectedDate.end,
        limit: vm.limit,
        offset: vm.offset,
        role: vm.$store.state.privilege.role
      }

      data = { ...data, ...vm.handleFormatDataBeforeGetTicket(data) }

      const allGet = [vm.ticket2getticket(data), vm.handleGetCountTicket(data)]
      vm.loading = true
      vm.countTicketLoading = true
      await Promise.all(allGet)
      vm.countTicketLoading = false
      vm.loading = false
      return true
    },
    ticket2getticket(data) {
      const vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      this.loading = true
      api.ticket2getticket(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.tickets = response.data
          this.pagetotal = parseInt(response.total)
        }
      })
    },

    async onExportTicket(callback) {
      const vm = this
      if (callback) {
        let { limit, offset } = callback
        let json = []

        const filter = this.formatFilter()

        vm.exportloading = true
        let data = {
          pageid: this.selectedBot.pageid,
          role: this.$store.state.privilege.role,
          limit,
          offset,
          ...filter
        }

        data = { ...data, ...vm.handleFormatDataBeforeGetTicket(data) }
        // eslint-disable-next-line no-unused-vars
        const { channel, ...rest } = data
        try {
          const response = await this.handleTicket2getticket(rest)
          let tickets = []
          if (response.data) {
            tickets = response.data
          }
          json = tickets.map((el) => {
            let objData = {
              ID: el.id ? el.id : '-',
              Priority: el.priority ? el.priority : '-'
            }

            if ([...this.$store.state.oceanlifePage].includes(this.selectedBot.pageid)) {
              let extraExport = {
                คะแนนความพึงพอใจ: el.satisfaction_score ? el.satisfaction_score : '-',
                คะแนนในการแนะนำบริการ: el.recommendation_score ? el.recommendation_score : '-'
              }
              Object.assign(objData, extraExport)
            }

            let adminTakeTime =
              el.starttime && el.adminfirstresponsetime
                ? this.durationTime(el.starttime, el.adminfirstresponsetime)
                : '-'

            const channel = this.$store.state.nestlePages.some(
              (page) => page.pageid == this.selectedBot.pageid
            )
              ? this.selectedBot.pagename
              : el.app

            Object.assign(objData, {
              Name: el.first_name
                ? `${el.first_name}${el.last_name ? ` ${el.last_name}` : ''}`
                : '-',
              'Latest Email': el.email ? el.email : '-',
              Channel: channel ? channel : '-',
              Subject: el.subject ? el.subject : '-',
              Details: el.details ? el.details : '-',
              Status: el.status ? el.status : '-',
              'Assign To': el.assignadminid ? el.assignadminid : '-',
              // Group: this.groups[el.assigngroupid] ? this.groups[el.assigngroupid].groupname : '-',
              // Subgroup: this.subgroups[el.assignsubgroupid]
              //   ? this.subgroups[el.assignsubgroupid].subgroupname
              //   : '-',
              'Start time (Date)': el.starttime ? moment(el.starttime).format('DD/MM/YYYY') : '-',
              'Start time (Time)': el.starttime ? moment(el.starttime).format('HH:mm') : '-',
              'Admin First Response (Date)': el.adminfirstresponsetime
                ? moment(el.adminfirstresponsetime).format('DD/MM/YYYY')
                : '-',
              'Admin First Response (Time)': el.adminfirstresponsetime
                ? moment(el.adminfirstresponsetime).format('HH:mm')
                : '-',
              'Admin take time': adminTakeTime,
              'End Time': el.endtime ? moment(el.endtime).format('DD/MM/YYYY HH:mm') : '-',
              'Time Closed':
                el.starttime && el.endtime ? this.durationTime(el.starttime, el.endtime) : '-',
              'Due Date': el.duedate ? el.duedate : '-',
              Tags: el.tags ? el.tags : '-'
            })

            return objData
          })

          callback.submitData(json)
        } catch (error) {
          console.error(error)
        } finally {
          vm.exportloading = false
        }
      }
    },
    async handleGetCountTicket(data) {
      const vm = this
      try {
        if (['studio7'].includes(vm.selectedBot.theme)) {
          if (vm.filter.pageid) {
            const tempSelectPage = vm.$store.state.com7pages.find((el) => {
              return el.pageid == vm.filter.pageid
            })

            if (tempSelectPage) {
              Object.assign(data, { pageSelect: tempSelectPage.name })
            } else {
              Object.assign(data, { pageSelect: 'All' })
            }
          } else {
            Object.assign(data, { pageSelect: 'All' })
          }
        }

        const response = await api.ticket2GetCountTicket(data)

        if (response) {
          vm.countTicketData = response.data
        }
      } catch (error) {
        vm.countTicketLoading = false
        console.error(error)
        return
      }
    },
    handleCloseSearch() {
      this.showAdvancedSearch = false
    }
  }
}
</script>

<style lang="scss">
.labelinputontop {
  position: absolute;
  top: -9px;
  left: 12px;
  font-size: 14px;
  color: #8c8c8c;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/ticket2/management/Management.vue